module.exports = "/fonts/fa-regular-400.woff2?bd42a2f17bdd2cdd2a40bd46f69224cf";